module.exports = __webpack_public_path__ + "img/HZMB_RENEW_PERSON.c4682faf.png";